export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/financial-experiments-thumb-e5e31372f6618f7aa3f5c917761446c2.png";